import { StoreService } from './store.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  currentUser: any;
  redirecto: string;
  allUserCode = '';
  constructor(private apiService: ApiService, private store: StoreService) { }

  logout(login: string) {
    return this.apiService.get('logout?login=' + login);
  }
  login(credentials: { login: string; password: string }) {
    return this.apiService.post('agent/login', credentials);
  }

  changerPassword(credentials: { oldPassword: string, newPassword: string, confirmeNewPassword: string, login: string }) {
    return this.apiService.post('agent/changePassword', credentials);
  }

  async checkMe(): Promise<any> {
    // this.me();
    console.log('checkMe store.data', this.store.data);
    if (this.currentUser || (this.store.data.user && this.store.data.accessToken)) {
      this.currentUser = this.store.data.user;
      return this.currentUser;
    }
    return null;
  }
  async me() {
    // if (this.currentUser) {
    //   return this.currentUser;
    // }
    try {
      const user = await this.apiService.get('agent/me').toPromise();
      this.currentUser = user;
      return this.currentUser;
    } catch (error) {

      window.location.href = '#/login';
      return null;
    }
  }
  hasDroit2(code: any, allDroit: any) {
    return allDroit.includes(code);
  }
  async hasDroit(code: any) {
    const allUserDroit = await this.store.getValue('allUserCode');
    return allUserDroit.includes(code);
  }
}
